const AskPasswordStatus = {
    REQUIRE_PASSWORD: 1,
    WRONG_PASSWORD: 2,
} as const;

export default AskPasswordStatus;
